const statusMapEnum = {
  INACTIVE: "Inativo",
  ACTIVE: "Ativo",
};

export default Object.freeze(statusMapEnum);
